import React, { useRef, useState } from "react";
import Box from "@mui/material/Box";
import NotFound from "../../../notFound/NotFound";
import UserList from "../organisms/UserList";
import UserListLabel from "../molecules/UserListLabel";
import ArrowCircleLeftIcon from "@mui/icons-material/ArrowCircleLeft";
import ArrowCircleRightIcon from "@mui/icons-material/ArrowCircleRight";
import { BigHeadline } from "../../../../components/TextParts";
import UserRegisterButton from "../molecules/UserRegisterButton";

export default function AdminManagement() {
  const userListRef = useRef(null);
  const [isShowUserListRightArrow, setIsShowUserListRightArrow] = useState(true);
  const [isShowUserListLeftArrow, setIsShowUserListLeftArrow] = useState(false);

  const onScroll = () => {
    if (userListRef.current) {
      const { scrollWidth, clientWidth, scrollLeft } = userListRef.current;
      const scrollRight = scrollWidth - clientWidth - scrollLeft;
      
      if (scrollLeft === 0) {
        setIsShowUserListLeftArrow(false);
      } else if (!isShowUserListLeftArrow) {
        setIsShowUserListLeftArrow(true);
      }
      
      if (scrollRight <= 1) { // 浮動小数点誤差対策
        setIsShowUserListRightArrow(false);
      } else if (!isShowUserListRightArrow) {
        setIsShowUserListRightArrow(true);
      }
    }
  };

  const adminFlag = Number(localStorage.getItem("adminFlag"));
  const hasAccess = 
    adminFlag === Number(process.env.REACT_APP_BP_MANAGEMENT_CLASS) ||
    adminFlag === Number(process.env.REACT_APP_MANAGEMENT_CLASS);

  if (!hasAccess) {
    return <NotFound />;
  }

  return (
    <Box sx={{ bgcolor: "#F2F3F4" }}>
      <Box sx={{ display: "flex" }}>
        <Box sx={{ flexGrow: 1 }}>
          <BigHeadline text="ユーザ管理" />
        </Box>
        <Box marginTop="60px" marginBottom="30px">
          <UserRegisterButton />
        </Box>
      </Box>
      <Box sx={{ position: "relative" }}>
        {isShowUserListLeftArrow && (
          <ArrowCircleLeftIcon
            sx={{
              display: { sm: "block", md: "none" },
              position: "absolute",
              left: 0,
              top: "50%",
              zIndex: 2,
              opacity: 0.5,
            }}
            fontSize="large"
            style={{ color: "#28345E" }}
          />
        )}
        {isShowUserListRightArrow && (
          <ArrowCircleRightIcon
            sx={{
              display: { sm: "block", md: "none" },
              position: "absolute",
              right: 0,
              top: "50%",
              zIndex: 2,
              opacity: 0.5,
            }}
            fontSize="large"
            style={{ color: "#28345E" }}
          />
        )}
        <Box
          sx={{
            flexGrow: 1,
            height: "calc( 100vh - 300px )",
            overflowY: "auto",
          }}
          ref={userListRef}
          onScroll={onScroll}
        >
          <Box sx={{ minWidth: "900px" }}>
            <Box sx={{ position: "sticky", top: 0, zIndex: 2 }}>
              <UserListLabel />
            </Box>
            <UserList />
          </Box>
        </Box>
      </Box>
    </Box>
  );
}